/**
 * Marks an unregistered player. Guest labels are self-chosen and never reserved,
 * so two players can share one and a guest can use a name someone else later
 * registers. This badge is the durable disambiguation.
 */
export function GuestBadge({ className = '' }: { className?: string }) {
  return (
    <span
      title="Guest — this name is not reserved"
      className={`inline-flex shrink-0 items-center rounded-full border border-current/20 bg-current/10 px-1.5 py-px text-[10px] font-bold uppercase tracking-wider opacity-60 ${className}`}
    >
      guest
    </span>
  );
}
